export default __webpack_public_path__ + "static/media/logo_prefeitura.e6a20a99.png";